import NavigationBar from '@/components/navigation-bar';
import Error404 from '@/modules/core/routes/error-404';
import {
  CatchNotFound,
  createFileRoute,
  Outlet,
  useLocation,
} from '@tanstack/react-router';
import {
  TirecloudUI,
  useTirecloudUIState,
} from '@thisisdmg/tirecloud-patterns/v2';
import classes from './index.module.css';
import VersionInfoModal from '@/components/version-info-modal';
import config from '@/modules/config/functions/config';
import PushNotificationModal from '@/modules/notifications/components/push-notification-modal';
import { useEffect, useRef, useState } from 'react';
import { ConfigProvider, theme } from 'antd';

function CloseTirecloudShellOnRouteChange() {
  const locationKey = useLocation({
    select: (loc) => `${loc.pathname}${loc.searchStr}`,
  });
  const prevLocationKeyRef = useRef<string | null>(null);
  const uiState = useTirecloudUIState();

  useEffect(() => {
    if (
      prevLocationKeyRef.current !== null &&
      prevLocationKeyRef.current !== locationKey
    ) {
      uiState.openCard(null);
      uiState.openBase(null);
    }
    prevLocationKeyRef.current = locationKey;
  }, [locationKey, uiState]);

  return null;
}

function NavigationBarContent() {
  const [showVersionInfo, setShowVersionInfo] = useState(false);
  const [showPushNotification, setShowPushNotification] = useState(false);

  return (
    <>
      <NavigationBar
        data-theme="dark"
        onVersionInfoClick={() => {
          setShowVersionInfo(true);
        }}
        onPushNotificationClick={() => {
          setShowPushNotification(true);
        }}
      />
      <ConfigProvider
        theme={{
          algorithm: theme.defaultAlgorithm,
        }}
      >
        <VersionInfoModal
          open={showVersionInfo}
          onClose={() => setShowVersionInfo(false)}
        />
        {config('features.pushNotification.enabled') === true && (
          <PushNotificationModal
            open={showPushNotification}
            onClose={() => setShowPushNotification(false)}
          />
        )}
      </ConfigProvider>
    </>
  );
}

function TirecloudUITemplate() {
  return (
    <>
      <TirecloudUI
        className={classes.main_ui}
        navigationBar={() => <NavigationBarContent />}
      >
        <CloseTirecloudShellOnRouteChange />
        <TirecloudUI.Content
          showContentToggle={false}
          allowBaseOpenOnMobile={false}
        >
          <main className={classes.main_ui__content}>
            <CatchNotFound fallback={() => <Error404 />}>
              <Outlet />
            </CatchNotFound>
          </main>
        </TirecloudUI.Content>
      </TirecloudUI>
    </>
  );
}

export const Route = createFileRoute('/_main-ui')({
  component: TirecloudUITemplate,
});
